import { Tooltip, Typography } from "antd";
import { StyledFlex } from "../Table/index.styled";
import { Link } from "react-router-dom";
import { CustomerLead } from "@lib/types/CustomerLead";
import { getRoute } from "@lib/helpers/RouteHelper";
import { ROUTES } from "@lib/constants";
import { useTypedSelector } from "@lib/redux";
import { AuthRoles } from "@lib/types";
import { useMemo } from "react";

type Props = {
  customerLead: CustomerLead;
  link?: boolean;
};

export default function CustomerLeadName({ customerLead, link }: Props) {
  const { user } = useTypedSelector((state) => state.auth);

  const customerLeadLink = useMemo(() => {
    switch (user?.role) {
      case AuthRoles.Admin:
        return getRoute(ROUTES.ADMIN.CUSTOMER_LEAD.DETAIL, {
          customerLeadId: customerLead?.id,
        });
      default:
        return null;
    }
  }, [user]);

  const name = customerLead
    ? `${customerLead?.firstName} ${customerLead?.lastName}`
    : " N/A ";

  if (!customerLead) return name;

  if (link && customerLeadLink) {
    return (
      <StyledFlex style={{ gap: 5 }}>
        <Tooltip title={name}>
          <Link to={customerLeadLink} style={{ cursor: "pointer" }}>
            <Typography.Text ellipsis>{name}</Typography.Text>
          </Link>
        </Tooltip>
      </StyledFlex>
    );
  }

  return (
    <StyledFlex style={{ gap: 5 }}>
      <Tooltip title={name}>
        <Typography.Text ellipsis>{name}</Typography.Text>
      </Tooltip>
    </StyledFlex>
  );
}
